import { jsxs as p, jsx as o } from "react/jsx-runtime";
import { a5 as u, d as v } from "../../vendor-EQDp64ng.js";
import { forwardRef as y, useState as N, useRef as I, useEffect as C } from "react";
import { BaseIcon as D } from "../BaseIcon/index.js";
import '../../assets/index7.css';const x = "_container_7iig7_1", G = "_image_7iig7_11", L = "_hidden_7iig7_21", P = "_errorOverlay_7iig7_26", U = "_pendingOverlay_7iig7_27", n = {
  container: x,
  image: G,
  hidden: L,
  errorOverlay: P,
  pendingOverlay: U
}, e = {
  ERROR: 3,
  IDLE: 0,
  PENDING: 1,
  SUCCESS: 2
}, b = y(
  ({ src: t, alt: s, aspectRatio: l, onLoad: m, onError: g, objectFit: R = "contain", lazy: E = !0, ...d }, f) => {
    const [a, r] = N(e.IDLE), i = I(null), S = u(f, i);
    C(() => {
      if (!i.current) {
        r(e.PENDING);
        return;
      }
      if (!t) {
        r(e.ERROR);
        return;
      }
      r(e.PENDING), i.current.complete && i.current.decode().then(() => r(e.SUCCESS)).catch(() => r(e.ERROR));
    }, [t]);
    const _ = (c) => {
      r(e.SUCCESS), m?.(c);
    }, O = (c) => {
      r(e.ERROR), g?.(c);
    }, h = v(n.image, {
      [n.hidden]: a !== e.SUCCESS
    });
    return /* @__PURE__ */ p("div", { className: n.container, style: { aspectRatio: l }, "data-component": "Image", children: [
      a === e.PENDING && /* @__PURE__ */ o("div", { className: n.pendingOverlay }),
      a === e.ERROR && /* @__PURE__ */ o("div", { className: n.errorOverlay, role: "img", "aria-label": s, children: /* @__PURE__ */ o(D, { icon: "photo-picture", size: "sm", color: "moon" }) }),
      /* @__PURE__ */ o(
        "img",
        {
          ...d,
          src: t || void 0,
          alt: s,
          "aria-hidden": d["aria-hidden"] || a === e.ERROR,
          loading: E ? "lazy" : "eager",
          decoding: "async",
          onLoad: _,
          onError: O,
          style: { objectFit: R },
          className: h,
          ref: S
        }
      )
    ] });
  }
);
export {
  b as Image
};
